<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="historicos && historicos.length">
      <px-historico :historicos="historicos" :fields="defaultFields"/>
    </div>
    <div v-if="!loading && !historicos.length"
         align="center"
         class="heading font-weight-bold mb-5 pb-5">
      Ainda não há históricos de alteração
    </div>
  </div>
</template>

<script>
import RespostaService from '../resposta-service';
import HistoricoDefaultFields from './historico-default-fields';

export default {
  props: {
    resposta: Object,
  },
  data() {
    return {
      historicos: [],
      loading: false,
      defaultFields: HistoricoDefaultFields.keys,
    };
  },
  methods: {
    getHistorico() {
      this.loading = true;
      RespostaService.getHistorico(this.resposta.cotacao.id, this.resposta.id)
        .then(({ data }) => {
          this.historicos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getHistorico();
  },
};
</script>
